import React, {Component} from "react";
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';
import {geocodeByAddress, getLatLng} from 'react-places-autocomplete';

import CreateForm from './CreateForm';
import {addLocation} from '../../../actions/locationActions';
import { isSimilarObject } from "../../../helper";

class StaffCreate extends Component {

    state = {
        title: '',
        comment: '',
        address: '',
        latitude: '',
        longitude: '',
        radius: '',

        errorMessages: {},
        isFetching: false,
    }

    componentDidMount() {
        let settings = this.props.data['settings']
    
        this.setState({
            radius: settings.default_address_radius || '',
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const {data} = this.props;
        let settings = data['settings']

        if(!isSimilarObject(settings, prevProps.settings)) {
            if(this.state.radius !== '' || !settings.data) return false;

            this.setState({
                radius: settings.data.default_address_radius
            });
        }
    }

    handleOnChange(value, field) {
        this.setState({
            [field]: value,
        })
    }

    handleAddressText(_address) {
        if (!_address.trim()) {
            this.setState({
                    address: "",
                    latitude: null,
                    longitude: null
            })
            return;
        }

        this.setState({
            latitude: null,
            longitude: null,
            address: _address
           // checkChanged: true,
        })
    }

    getGeoCodeByAddress(address) {
        geocodeByAddress(address)
        .then(results => {
            return getLatLng(results[0])
        })
        .then(latLng =>
            this.handleChangeAddress(address, latLng)
        )
        .catch(error => console.error('Error', error))
    }

    handleChangeAddress(address, pos) {
        this.setState({
                address: address,
                latitude: pos.lat,
                longitude: pos.lng
        }, () => {
            if(this.state.isMap) this.initMap();
        })
    }

    isEmpty(string) {
        if(!string) return false;
        string = string.toString();
        if(!(string.trim().length)) return false;
        return true;
    }

    isNumber(number) {
        if (number === undefined || number === NaN || number === null || number.toString().trim() === ""){
            return false;
        }
        return true;
    }

    getError(error, value) {
        switch(error) {
            case 'is_empty':
                return 'Обязательное поле';
            case 'is_number':
                return 'Только числовое значение';
            case 'is_coor':
                return 'Координаты места указаны не корректно';
            case 'is_select':
                return 'Выберите значение из списка';
            case 'not_correct':
                return `Название ${value} указана не корректно`;
        }
    }

    checkValidation() {
        let {
            address,
            latitude,
            longitude,
            title,
            comment,
            radius,
            errorMessages,
        } = this.state;

        errorMessages = {};

        if(!this.isEmpty(title)) {
            errorMessages = {
                ...errorMessages,
                title: [this.getError('is_empty')]
            }
        }

        if(!this.isNumber(longitude) || !this.isNumber(latitude)) {
            errorMessages = {
                ...errorMessages,
                address: [this.getError('is_select')]
            }
        }

        if(!this.isEmpty(address)) {
            errorMessages = {
                ...errorMessages,
                address: [this.getError('is_empty')]
            }
        }

        if(!this.isNumber(radius)) {
            errorMessages = {
                ...errorMessages,
                radius: [this.getError('is_select')]
            }
        }
        
        this.setState({
            errorMessages,
        });

        if(Object.keys(errorMessages).length > 0) {
            return false;
        }

        return true;
    }

    onSubmit(e) {
        e.preventDefault();

        const {address, latitude, longitude, title, comment, radius} = this.state;

        let params = {
            address,
            latitude,
            longitude,
            title,
            comment,
            radius
        };

        if(!this.checkValidation()) {
            Alert.error('Исправьте ошибки', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });
            return false;
        }

        this.setState({
            isFetching: true
        });

        this.props.addLocation(
            params,
            (data) => {
                this.setState({
                    title: '',
                    comment: '',
                    address: '',
                    latitude: '',
                    longitude: '',
                    radius: '',
                    isFetching: false
                });
                Alert.success('Адрес успешно добавлен', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            },
            (message) => {
                Alert.error(message, {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
                this.setState({
                    isFetching: false
                })
            }
        );
    }

    render() {
        const {
            session:{currentUser}
        } = this.props;

        // if(!companies.data.results.length) {
        //     return <CreateCompanyMessage />
        // }

        return(
            <div className="right-content native-scroll right-content-width">
                <div className="screen-outer-block-wrap native-scroll menu-content">
                    <div className="menu-content-balance menu-content-item tab-parent screen-bottom-block">
                    
                        <div className="rounded-white-block"> 

                            <div className="tab-content profile-info tab-content1 active">
                                <div className="menu-content-staff menu-content-item tab-parent screen-bottom-block">

                                    <Alert stack={{limit: 1}} />

                                    <div className="rounded-white-block">
                                        <div className="white-block-top">
                                            <h3>Новый адрес</h3>
                                        </div>

                                        <CreateForm
                                            {...this.state}
                                            isFetching={this.state.isFetching}
                                            handleAddressText={(address) => this.handleAddressText(address)}
                                            handleOnChange={(value, field) => this.handleOnChange(value, field)}
                                            getGeoCodeByAddress={(address) => this.getGeoCodeByAddress(address)}
                                            onSubmit={(e) => this.onSubmit(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(
    mapStateToProps,
    {addLocation}
)(StaffCreate);


// WEBPACK FOOTER //
// ./src/components/Account/Locations/LocationCreate.js